<template>
  <transition name="fade">
    <div v-show="validationData.inputMetadata.showErrorMsg && showError" class="red--text text--lighten-3 text-caption">
      <span v-html="msg" />
    </div>
  </transition>
</template>

<script>
import { validateValue } from '../helpers/validation.js'
export default {
  props: { validationData: Object },
  data() {
    return {
      msg: "",
      showError: false,
    };
  },
  watch: {
    validationData: {
      immediate: true,
      handler() {
        this.handleWatch();
      },
    },
    "validationData.inputMetadata.showErrorMsg": {
      immediate: true,
      handler() {
        this.handleWatch();
      },
    },
  },
  methods: {
    validateInput: function () {
      let inputMetadata = this.validationData.inputMetadata;
      let val = this.validationData.val;
      let rules = this.validationData.rules;
      if (val !== null && val !== undefined && inputMetadata.showErrorMsg) {
        let result = validateValue(val, rules);
        if (result.errormsgs.length > 0) {
          return result.errormsgs[0];
        }
      }
      return "";
    },
    handleWatch() {
      let msg = this.validateInput();
      this.showError = Boolean(msg);
      if (msg) {
        this.msg = msg;
      }
    },
  },
};
</script>

<style scoped>
.parent {
  overflow: clip;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}
.fade-enter-from {
  opacity: 0;
  max-height: 0px;
}
.fade-enter-to {
  opacity: 1;
  max-height: 4rem;
}

.fade-enter-active {
  transition: all 0.25s;
}

.fade-leave-from {
  opacity: 1;
  max-height: 4rem;
}
.fade-leave-to {
  opacity: 0;
  max-height: 0px;
}

.fade-leave-active {
  transition: all 0.25s;
}
</style>
